import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import UserDetails from "./UserDetails";
import NewUserForm from "./NewUserForm";
import AdminPasswordChange from "./AdminPasswordChange";
import PasswordChange from "./PasswordChange";
import UserAccessChange from "./UserAccessChange";
import "../style/UserManagement.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faKey,
  faUnlock,
  faUserEdit,
  faUserGroup,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

export default function UserManagement() {
  const location = useLocation();
  const passedState = location.state;

  const [currentForm, setCurrentForm] = useState("userDetails");
  const [isActive, setIsActive] = useState(0);

  const[username,setUsername]=useState('')
  const[rights,setRights]=useState('')

  useEffect(()=>{
    setUsername(sessionStorage.getItem('username'))
    setRights(sessionStorage.getItem('rights'))
  })

  const renderForm = () => {
    switch (currentForm) {
      case "userDetails":
        return <UserDetails username={username} />;
      case "activateNewUser":
        return <NewUserForm username={username} />;
      case "adminPasswordChange":
        return <AdminPasswordChange username={username} />;
      case "passwordChange":
        return <PasswordChange username={username} />;
      case "userAccessDetailsChange":
        return <UserAccessChange username={username} />;
      default:
        return null;
    }
  };

  return (
    <>
      <Appbar
        username={username}
        rights={rights}
      ></Appbar>
      <div className="UserManagement">
        <Menu
          username={username}
          rights={rights}
          i={"MasterSetup"}
        ></Menu>
        <div className="UserManagementPage">
          <p className="UserManagementPageHeadLabel">User Management</p>
          <div className="UserManagementPageTabBox">
            <div className="UserManagementPageTabs">
              <button
                title="User Details"
                className={
                  isActive === 0
                    ? "UserManagementPageTabBtns Active"
                    : "UserManagementPageTabBtns"
                }
                onClick={() => {
                  setIsActive(0);
                  setCurrentForm("userDetails");
                }}
              >
                {isActive === 0 ? "User Details" : ""}{" "}
                <FontAwesomeIcon
                  className="USMicons"
                  icon={faUserGroup}
                ></FontAwesomeIcon>
              </button>
              <button
                title="Password Change"
                className={
                  isActive === 1
                    ? "UserManagementPageTabBtns Active"
                    : "UserManagementPageTabBtns"
                }
                onClick={() => {
                  setIsActive(1);
                  setCurrentForm("passwordChange");
                }}
              >
                {isActive === 1 ? "Password Change" : ""}{" "}
                <FontAwesomeIcon
                  className="USMicons"
                  icon={faUnlock}
                ></FontAwesomeIcon>
              </button>
              <button
                title="Activate New User"
                className={
                  isActive === 2
                    ? "UserManagementPageTabBtns Active"
                    : "UserManagementPageTabBtns"
                }
                onClick={
                  rights === "A"
                    ? () => {
                        setIsActive(2);
                        setCurrentForm("activateNewUser");
                      }
                    : () => {}
                }
              >
                {isActive === 2 ? "Activate New User" : ""}
                <FontAwesomeIcon
                  className="USMicons"
                  icon={faUserPlus}
                ></FontAwesomeIcon>
              </button>
              <button
                title="User Access Details Change"
                className={
                  isActive === 3
                    ? "UserManagementPageTabBtns Active"
                    : "UserManagementPageTabBtns"
                }
                onClick={
                  rights === "A"
                    ? () => {
                        setIsActive(3);
                        setCurrentForm("userAccessDetailsChange");
                      }
                    : () => {}
                }
              >
                {isActive === 3 ? "User Access Details Change" : ""}
                <FontAwesomeIcon
                  className="USMicons"
                  icon={faUserEdit}
                ></FontAwesomeIcon>
              </button>
              <button
                title="Admin Password Change"
                className={
                  isActive === 4
                    ? "UserManagementPageTabBtns Active"
                    : "UserManagementPageTabBtns"
                }
                onClick={
                  rights === "A"
                    ? () => {
                        setIsActive(4);
                        setCurrentForm("adminPasswordChange");
                      }
                    : () => {}
                }
              >
                {isActive === 4 ? "Admin Password Change" : ""}
                <FontAwesomeIcon
                  className="USMicons"
                  icon={faKey}
                ></FontAwesomeIcon>
              </button>
            </div>
          </div>

          <div className="UserManagementPageContent">{renderForm()}</div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}
